import type { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from '~/components/RadioGroup';
import { FilterTagTooltip } from '~/modules/artist-roster/components/FilterTagTooltip/FilterTagTooltip';
import { TRACK_RELEASE_TYPE_OPTIONS } from '~/modules/artist-roster/pages/artist-details/utils/constants';
import type { TrackReleaseType } from '~/modules/artist-roster/pages/artist-details/utils/types';

type TrackReleaseOrAllType = TrackReleaseType | 'all';

export function TrackReleaseTypeFilter() {
  const { t } = useTranslation('roster');
  const { watch, setValue } = useFormContext();
  const filterKey = 'releaseType';
  const filterValue: TrackReleaseOrAllType = watch(filterKey) || 'all';

  const handleTagClick = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(filterKey, event.target.value, {
      shouldDirty: true,
    });
  };

  return (
    <RadioGroup
      className="py-sm"
      options={[
        {
          value: 'all',
          label: t('all.label'),
        },
        ...TRACK_RELEASE_TYPE_OPTIONS.map((type) => ({
          value: type,
          label: (
            <>
              {t(`filters.releaseType.${type}.label`)}
              <FilterTagTooltip
                trans={{ i18nKey: `filters.releaseType.${type}.tooltip` }}
              />
            </>
          ),
        })),
      ]}
      name={filterKey}
      value={filterValue}
      onChange={handleTagClick}
    />
  );
}

TrackReleaseTypeFilter.displayName = 'TrackReleaseTypeFilter';
